import { Flex, type FlexProps, INDEX_TEXT_WIDTH, Text } from '@/components';
import { FALLBACK_TEXT } from '@/utils';
import {
  type ComponentProps,
  type FC,
  type ReactNode,
  isValidElement,
  useMemo,
} from 'react';
import {
  PDF_BORDER,
  SECTION_ITEM_PADDING,
  SECTION_TITLE_BACKGROUND_COLOR,
} from './constants';

type Props = {
  label?: string;
  isSpaceLabel?: boolean;
  value: ReactNode;
  wrapperStyle?: FlexProps['style'];
  labelStyle?: FlexProps['style'];
  valueWrapperStyle?: FlexProps['style'];
  isLast?: boolean;
  isTable?: boolean;
  hasLeftBorder?: boolean;
  hasWrapperFlex?: boolean;
  indexText?: string;
};

export const ReportSectionItemContent: FC<Props> = ({
  label,
  isSpaceLabel,
  value,
  labelStyle,
  wrapperStyle,
  valueWrapperStyle,
  hasLeftBorder,
  hasWrapperFlex = true,
  indexText,
}) => {
  const contents = useMemo(() => {
    return (
      <>
        {indexText && (
          <Flex
            align="center"
            style={{
              padding: SECTION_ITEM_PADDING,
              background: SECTION_TITLE_BACKGROUND_COLOR,
              borderRight: PDF_BORDER.THIN,
              width: INDEX_TEXT_WIDTH,
              boxSizing: 'border-box',
              ...labelStyle,
            }}
          >
            <Text variant="footnote" weight="bold" text={indexText} />
          </Flex>
        )}
        {(label || isSpaceLabel) && (
          <Flex
            align="center"
            style={{
              padding: SECTION_ITEM_PADDING,
              background: SECTION_TITLE_BACKGROUND_COLOR,
              borderRight: PDF_BORDER.THIN,
              width: 140,
              minWidth: 140,
              boxSizing: 'border-box',
              ...labelStyle,
            }}
          >
            <Text
              variant="footnote"
              weight="bold"
              text={isSpaceLabel ? '' : label}
            />
          </Flex>
        )}
        {isValidElement(value) ? (
          <>{value}</>
        ) : (
          <Flex
            align="center"
            style={{
              flex: 1,
              padding: SECTION_ITEM_PADDING,
              boxSizing: 'border-box',
              ...valueWrapperStyle,
            }}
          >
            <Text
              variant="footnote"
              text={
                (value as ComponentProps<typeof Text>['text']) || FALLBACK_TEXT
              }
            />
          </Flex>
        )}
      </>
    );
  }, [indexText, label, isSpaceLabel, labelStyle, valueWrapperStyle, value]);

  if (!hasWrapperFlex) {
    return contents;
  }

  return (
    <Flex
      style={{
        flex: 1,
        breakInside: 'avoid',
        boxSizing: 'border-box',
        // borderBottom: isLast || isTable ? 'none' : PDF_BORDER.THIN,
        borderLeft: hasLeftBorder ? PDF_BORDER.THIN : 'none',
        ...wrapperStyle,
      }}
    >
      {contents}
    </Flex>
  );
};
